// extracted by mini-css-extract-plugin
export default {"comfortBuy":"puHAJ","advantagesList":"Vaq2Q","advantagesItem":"VU41B","advantagesPic":"a1Kfa","cnImage":"HSjJM","heading":"yg8gY","description":"QHjy_","note":"KeYI2"};